export const siemMessages = {
  en: {
    siem: {
      // ── Tags ─────────────────────────────────────────────────────────────
      tags: {
        colId: 'ID',
        colName: 'Name',
        colDescription: 'Description',
        addBtn: 'New Tag',
        editTooltip: 'Edit',
        deleteTooltip: 'Delete',
        dialogCreate: 'Add Tag',
        dialogEdit: 'Edit Tag',
        formName: 'Name',
        formDescription: 'Description',
        nameMissing: 'Please enter a name.',
        saved: 'Saved',
        tagCreated: 'Tag created.',
        tagUpdated: 'Tag updated.',
        deleted: 'Deleted',
        tagDeleted: 'Tag removed.',
        loadFailed: 'Tags could not be loaded.',
        saveFailed: 'Save failed.',
        deleteFailed: 'Delete failed.',
        confirmDelete: 'Really delete this tag?',
      },

      // ── Streams ──────────────────────────────────────────────────────────
      streams: {
        colId: 'ID',
        colType: 'Type',
        colName: 'Name',
        colCategory: 'Category',
        colSubcategory: 'Subcategory',
        colCompany: 'Company',
        colCreated: 'Created',
        colTags: 'Tags',
        addBtn: 'New Stream',
        editTooltip: 'Edit',
        deleteTooltip: 'Delete',
        dialogCreate: 'Add Stream',
        dialogEdit: 'Edit Stream',
        dialogClone: 'Clone Stream',
        formGuid: 'GUID',
        formGuidPlaceholder: 'Optional for custom streams',
        formGuidHint: 'Only needed for managed streams. Custom streams receive their ID via the sync daemon.',
        formName: 'Name',
        formCategory: 'Category',
        formSubcategory: 'Subcategory',
        formTags: 'Tags',
        formTagsPlaceholder: 'Select tags',
        formTagsHint: 'Global SIEM tags (shared with workflows). Pushed to Enginsight on sync.',
        formParameters: 'Search Query (Lucene)',
        formParametersPlaceholder: 'ngs.source:"windowsEventLog" AND winlog.System.EventID:"4899"',
        formParametersHint: 'Apache Lucene syntax — field:value pairs connected with AND / OR / NOT',
        formParametersPreview: 'Preview',
        expansionQuery: 'Filter Query',
        expansionNoQuery: 'No query defined for this stream.',
        nameMissing: 'Please enter a name.',
        invalidJson: 'Parameters must be valid JSON.',
        typeManaged: 'Managed',
        typeCustom: 'Custom',
        cloneTooltip: 'Clone',
        cloned: 'Cloned',
        streamCloned: 'Stream cloned as custom copy.',
        cloneFailed: 'Clone failed.',
        managedHint: 'This is a managed stream (imported by the streamer). It cannot be edited or deleted.',
        editNotAllowed: 'This stream cannot be edited (managed or belongs to another company).',
        colVisibility: 'Visibility',
        visibility: 'Visibility',
        visCompany: 'Company',
        visCommunity: 'Community',
        visCompanyHint: 'Only visible to members of your company',
        visCommunityHint: 'Visible to all platform users',
        statsTypes: 'Stream Types',
        statsCategories: 'Categories',
        statsSubcategories: 'Subcategories',
        statsVisibility: 'Visibility',
        statsOther: 'Other',
        statsUncategorized: 'Uncategorized',
        statsLoadFailed: 'Failed to load stream statistics.',
        formVisibility: 'Visibility',
        cloneVisibilityLabel: 'Visibility for clone',
        notOwner: 'You can only edit streams owned by your company.',
        saved: 'Saved',
        streamCreated: 'Stream created.',
        streamUpdated: 'Stream updated.',
        deleted: 'Deleted',
        streamDeleted: 'Stream removed.',
        loadFailed: 'Streams could not be loaded.',
        saveFailed: 'Save failed.',
        deleteFailed: 'Delete failed.',
        confirmDelete: 'Really delete this stream?',
        // ── Filter & Summary ──
        statsTotal: 'All',
        filterAllTypes: 'All types',
        filterAllVis: 'All visibilities',
        filterAllCategories: 'All categories',
        filterAllSubcategories: 'All subcategories',
        filterType: 'Type',
        filterVisibility: 'Visibility',
        filterCategory: 'Category',
        filterSubcategory: 'Subcategory',
        filterReset: 'Reset filters',
        activeFilters: 'active filter | active filters',
        noMatch: 'No streams match the active filters.',
        // ── Wrapper / Combination streams ──
        typeSingle: 'Single query',
        typeCombination: 'Combination',
        typeSingleDesc: 'One Lucene query you write yourself.',
        typeCombinationDesc: 'Combine existing streams with AND/OR.',
        combinationHint: 'Combination stream: built from other streams via AND/OR.',
        formType: 'Stream type',
        formTypeHint: 'Single query = one Lucene query. Combination = combine existing streams with AND/OR.',
        formCombination: 'Stream combination',
        formCombinationHint: 'Combine existing streams with AND/OR. Sub-groups allow nested logic.',
        formCombinationPreview: 'Final data query (derived)',
        combinationPreviewEmpty: 'Add conditions to see the derived query.',
        combinationEmpty: 'A combination must reference at least one stream.',
      },

      // ── Filters ───────────────────────────────────────────────────────────
      filters: {
        pageTitle: 'SIEM Filters',
        colDescription: 'Description',
        colWorkflowId: 'Workflow ID',
        colCondition: 'Condition',
        colSyntax: 'Syntax',
        addBtn: 'Add Filter',
        editTooltip: 'Edit',
        deleteTooltip: 'Delete',
        dialogCreate: 'Add Filter',
        dialogEdit: 'Edit Filter',
        formDescription: 'Description',
        formCondition: 'Condition',
        formProvider: 'Vendor Syntax (Provider)',
        formProviderPlaceholder: 'Please select',
        noFilters: 'No filters available.',
        saved: 'Saved',
        filterCreated: 'Filter created.',
        filterUpdated: 'Filter updated.',
        deleted: 'Deleted',
        filterDeleted: 'Filter removed.',
        loadFailed: 'Filters could not be loaded.',
        providerLoadFailed: 'Providers could not be loaded.',
        saveFailed: 'Save failed.',
        deleteFailed: 'Delete failed.',
        confirmDelete: 'Really delete this filter?',
      },

      // ── Providers ─────────────────────────────────────────────────────────
      providers: {
        pageTitle: 'SIEM Providers',
        colId: 'ID',
        colName: 'Name',
        colDescription: 'Description',
        addBtn: 'Add Provider',
        editTooltip: 'Edit',
        deleteTooltip: 'Delete',
        dialogCreate: 'Add Provider',
        dialogEdit: 'Edit Provider',
        formName: 'Name',
        formDescription: 'Description',
        noProviders: 'No providers available.',
        saved: 'Saved',
        providerCreated: 'Provider created.',
        providerUpdated: 'Provider updated.',
        deleted: 'Deleted',
        providerDeleted: 'Provider removed.',
        loadFailed: 'Providers could not be loaded.',
        saveFailed: 'Save failed.',
        deleteFailed: 'Delete failed.',
        confirmDelete: 'Really delete this provider?',
      },

      // ── Settings ──────────────────────────────────────────────────────────
      settings: {
        pageTitle: 'Settings',
      },
    },
    streamPicker: {
      title: 'Add stream',
      colName: 'Name',
      colCategory: 'Category',
      colSubcategory: 'Subcategory',
      colScope: 'Scope',
      allCategories: 'All categories',
      allScopes: 'All scopes',
      scopeManaged: 'Managed',
      scopeCommunity: 'Community',
      scopeCompany: 'Company',
      choose: 'Add',
      used: 'In use',
      empty: 'No streams found.',
    },
    streamCombination: {
      and: 'AND',
      or: 'OR',
      opHint: 'Link the conditions in this group with',
      addCondition: 'Condition',
      addSubgroup: 'Sub-group',
      removeGroup: 'Remove group',
      emptyGroup: 'No conditions yet — add a stream or a sub-group.',
    },
  },
  de: {
    siem: {
      tags: {
        colId: 'ID',
        colName: 'Name',
        colDescription: 'Beschreibung',
        addBtn: 'Neuer Tag',
        editTooltip: 'Bearbeiten',
        deleteTooltip: 'Löschen',
        dialogCreate: 'Tag hinzufügen',
        dialogEdit: 'Tag bearbeiten',
        formName: 'Name',
        formDescription: 'Beschreibung',
        nameMissing: 'Bitte einen Namen angeben.',
        saved: 'Gespeichert',
        tagCreated: 'Tag wurde erstellt.',
        tagUpdated: 'Tag wurde aktualisiert.',
        deleted: 'Gelöscht',
        tagDeleted: 'Tag wurde entfernt.',
        loadFailed: 'Tags konnten nicht geladen werden.',
        saveFailed: 'Speichern fehlgeschlagen.',
        deleteFailed: 'Löschen fehlgeschlagen.',
        confirmDelete: 'Möchtest du diesen Tag wirklich löschen?',
      },

      streams: {
        colId: 'ID',
        colType: 'Typ',
        colName: 'Name',
        colCategory: 'Kategorie',
        colSubcategory: 'Unterkategorie',
        colCompany: 'Unternehmen',
        colCreated: 'Erstellt',
        colTags: 'Tags',
        addBtn: 'Neuer Stream',
        editTooltip: 'Bearbeiten',
        deleteTooltip: 'Löschen',
        dialogCreate: 'Stream hinzufügen',
        dialogEdit: 'Stream bearbeiten',
        dialogClone: 'Stream klonen',
        formGuid: 'GUID',
        formGuidPlaceholder: 'Optional für Custom-Streams',
        formGuidHint: 'Nur für Managed Streams erforderlich. Custom Streams erhalten ihre ID durch den Sync-Daemon.',
        formName: 'Name',
        formCategory: 'Kategorie',
        formSubcategory: 'Unterkategorie',
        formTags: 'Tags',
        formTagsPlaceholder: 'Tags auswählen',
        formTagsHint: 'Globale SIEM-Tags (geteilt mit Workflows). Werden beim Sync nach Enginsight gepusht.',
        formParameters: 'Suchquery (Lucene)',
        formParametersPlaceholder: 'ngs.source:"windowsEventLog" AND winlog.System.EventID:"4899"',
        formParametersHint: 'Apache-Lucene-Syntax — Feld:Wert-Paare verknüpft mit AND / OR / NOT',
        formParametersPreview: 'Vorschau',
        expansionQuery: 'Filter-Query',
        expansionNoQuery: 'Für diesen Stream ist keine Query definiert.',
        nameMissing: 'Bitte einen Namen angeben.',
        invalidJson: 'Parameter müssen gültiges JSON sein.',
        typeManaged: 'Managed',
        typeCustom: 'Custom',
        cloneTooltip: 'Klonen',
        cloned: 'Geklont',
        streamCloned: 'Stream als Custom-Kopie angelegt.',
        cloneFailed: 'Klonen fehlgeschlagen.',
        managedHint: 'Dies ist ein verwalteter Stream (vom Streamer importiert). Er kann nicht bearbeitet oder gelöscht werden.',
        editNotAllowed: 'Dieser Stream kann nicht bearbeitet werden (verwaltet oder einer anderen Firma zugehörig).',
        colVisibility: 'Sichtbarkeit',
        visibility: 'Sichtbarkeit',
        visCompany: 'Unternehmen',
        visCommunity: 'Community',
        visCompanyHint: 'Nur für Mitglieder deines Unternehmens sichtbar',
        visCommunityHint: 'Für alle Plattform-Nutzer sichtbar',
        statsTypes: 'Stream-Typen',
        statsCategories: 'Kategorien',
        statsSubcategories: 'Unterkategorien',
        statsVisibility: 'Sichtbarkeit',
        statsOther: 'Andere',
        statsUncategorized: 'Ohne Kategorie',
        statsLoadFailed: 'Stream-Statistiken konnten nicht geladen werden.',
        formVisibility: 'Sichtbarkeit',
        cloneVisibilityLabel: 'Sichtbarkeit des Klons',
        notOwner: 'Du kannst nur Streams deines eigenen Unternehmens bearbeiten.',
        saved: 'Gespeichert',
        streamCreated: 'Stream wurde erstellt.',
        streamUpdated: 'Stream wurde aktualisiert.',
        deleted: 'Gelöscht',
        streamDeleted: 'Stream wurde entfernt.',
        loadFailed: 'Streams konnten nicht geladen werden.',
        saveFailed: 'Speichern fehlgeschlagen.',
        deleteFailed: 'Löschen fehlgeschlagen.',
        confirmDelete: 'Möchtest du diesen Stream wirklich löschen?',
        // ── Filter & Zusammenfassung ──
        statsTotal: 'Alle',
        filterAllTypes: 'Alle Typen',
        filterAllVis: 'Alle Sichtbarkeiten',
        filterAllCategories: 'Alle Kategorien',
        filterAllSubcategories: 'Alle Unterkategorien',
        filterType: 'Typ',
        filterVisibility: 'Sichtbarkeit',
        filterCategory: 'Kategorie',
        filterSubcategory: 'Unterkategorie',
        filterReset: 'Filter zurücksetzen',
        activeFilters: 'aktiver Filter | aktive Filter',
        noMatch: 'Keine Streams entsprechen den aktiven Filtern.',
        // ── Wrapper / Kombi-Streams ──
        typeSingle: 'Einzel-Query',
        typeCombination: 'Kombination',
        typeSingleDesc: 'Eine Lucene-Query, die du selbst schreibst.',
        typeCombinationDesc: 'Bestehende Streams via UND/ODER verknüpfen.',
        combinationHint: 'Kombi-Stream: aus anderen Streams via UND/ODER zusammengesetzt.',
        formType: 'Stream-Typ',
        formTypeHint: 'Einzel-Query = eine Lucene-Query. Kombination = bestehende Streams via UND/ODER verknüpfen.',
        formCombination: 'Stream-Kombination',
        formCombinationHint: 'Bestehende Streams via UND/ODER verknüpfen. Untergruppen erlauben geschachtelte Logik.',
        formCombinationPreview: 'Finale Daten-Query (abgeleitet)',
        combinationPreviewEmpty: 'Bedingungen hinzufügen, um die abgeleitete Query zu sehen.',
        combinationEmpty: 'Eine Kombination muss mindestens einen Stream referenzieren.',
      },

      filters: {
        pageTitle: 'SIEM Filter',
        colDescription: 'Beschreibung',
        colWorkflowId: 'Workflow ID',
        colCondition: 'Bedingung',
        colSyntax: 'Syntax',
        addBtn: 'Filter hinzufügen',
        editTooltip: 'Bearbeiten',
        deleteTooltip: 'Löschen',
        dialogCreate: 'Filter hinzufügen',
        dialogEdit: 'Filter bearbeiten',
        formDescription: 'Beschreibung',
        formCondition: 'Bedingung (Condition)',
        formProvider: 'Hersteller-Syntax (Provider)',
        formProviderPlaceholder: 'Bitte wählen',
        noFilters: 'Keine Filter vorhanden.',
        saved: 'Gespeichert',
        filterCreated: 'Filter wurde erstellt.',
        filterUpdated: 'Filter wurde aktualisiert.',
        deleted: 'Gelöscht',
        filterDeleted: 'Filter wurde entfernt.',
        loadFailed: 'Filter konnten nicht geladen werden.',
        providerLoadFailed: 'Provider konnten nicht geladen werden.',
        saveFailed: 'Speichern fehlgeschlagen.',
        deleteFailed: 'Löschen fehlgeschlagen.',
        confirmDelete: 'Möchten Sie diesen Filter wirklich löschen?',
      },

      providers: {
        pageTitle: 'SIEM Provider',
        colId: 'ID',
        colName: 'Name',
        colDescription: 'Beschreibung',
        addBtn: 'Provider hinzufügen',
        editTooltip: 'Bearbeiten',
        deleteTooltip: 'Löschen',
        dialogCreate: 'Provider hinzufügen',
        dialogEdit: 'Provider bearbeiten',
        formName: 'Name',
        formDescription: 'Beschreibung',
        noProviders: 'Keine Provider vorhanden.',
        saved: 'Gespeichert',
        providerCreated: 'Provider wurde erstellt.',
        providerUpdated: 'Provider wurde aktualisiert.',
        deleted: 'Gelöscht',
        providerDeleted: 'Provider wurde entfernt.',
        loadFailed: 'Provider konnten nicht geladen werden.',
        saveFailed: 'Speichern fehlgeschlagen.',
        deleteFailed: 'Löschen fehlgeschlagen.',
        confirmDelete: 'Möchten Sie diesen Provider wirklich löschen?',
      },

      settings: {
        pageTitle: 'Einstellungen',
      },
    },
    streamPicker: {
      title: 'Stream hinzufügen',
      colName: 'Name',
      colCategory: 'Kategorie',
      colSubcategory: 'Unterkategorie',
      colScope: 'Sichtbarkeit',
      allCategories: 'Alle Kategorien',
      allScopes: 'Alle Sichtbarkeiten',
      scopeManaged: 'Verwaltet',
      scopeCommunity: 'Community',
      scopeCompany: 'Unternehmen',
      choose: 'Hinzufügen',
      used: 'Verwendet',
      empty: 'Keine Streams gefunden.',
    },
    streamCombination: {
      and: 'UND',
      or: 'ODER',
      opHint: 'Bedingungen dieser Gruppe verknüpfen mit',
      addCondition: 'Bedingung',
      addSubgroup: 'Untergruppe',
      removeGroup: 'Gruppe entfernen',
      emptyGroup: 'Noch keine Bedingungen — Stream oder Untergruppe hinzufügen.',
    },
  },
}
